/**
 * Reducer that manages the state of In Person Therapy request
 */
// In person therapy request actions
import {
  REQUEST_IN_PERSON_THERAPY,
  REQUEST_IN_PERSON_THERAPY_DONE,
  REQUEST_IN_PERSON_THERAPY_ERROR,
  GET_IN_PERSON_THERAPY_STATUS_DONE,
  GET_IN_PERSON_THERAPY_STATUS,
  GET_IN_PERSON_THERAPY_STATUS_ERROR,
  CLEAR_IN_PERSON_THERAPY_STATUS_ERROR
} from '../../actions/types';

const INITIAL_STATE = {
  request: {
    isFetching: false,
    hasError: false
  },
  status: {
    isFetching: false
  },
  inPersonTherapyRequestDone: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQUEST_IN_PERSON_THERAPY:
      return {
        ...state,
        request: {
          isFetching: true,
          hasError: false
        }
      };
    case REQUEST_IN_PERSON_THERAPY_DONE:
      return {
        ...state,
        inPersonTherapyRequestDone: true,
        request: {
          isFetching: false,
          hasError: false
        }
      };
    case REQUEST_IN_PERSON_THERAPY_ERROR:
      return {
        ...state,
        request: {
          isFetching: false,
          hasError: true
        }
      };

    case GET_IN_PERSON_THERAPY_STATUS:
      return {
        ...state,
        status: {
          isFetching: true
        }
      };
    case GET_IN_PERSON_THERAPY_STATUS_DONE: {
      return {
        ...state,
        status: {
          isFetching: false
        },
        inPersonTherapyRequestDone: action.status
      };
    }
    case GET_IN_PERSON_THERAPY_STATUS_ERROR: {
      return {
        ...state,
        status: {
          isFetching: false
        }
      };
    }
    case CLEAR_IN_PERSON_THERAPY_STATUS_ERROR: {
      return {
        ...state,
        request: {
          hasError: false
        }
      };
    }
    default:
      return state;
  }
};
